import React, { useState } from 'react'
import Swal from 'sweetalert2'
import toast from 'react-hot-toast'
import FullScreenLoader from '../Components/FullScreenLoader'


const Foods = () => {

  const [loading, setLoading] = useState(false)
  
  const BASE_URl = window.location.origin

    const handleAddFood = async(e) => {
        e.preventDefault()
        const result = await Swal.fire({
              title: "Do you Want To add the Food Item",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, delete it!",
            });

            const formData = new FormData() 
            formData.append("title", e.target.title.value)
            formData.append("price", e.target.price.value)
            formData.append("description", e.target.description.value)
            formData.append("category", e.target.category.value)
            formData.append("file", e.target.file.files[0])
            if(result.isConfirmed){
              setLoading(true)
                fetch(`${BASE_URl}/api/addfood`, {
                    method: "POST",
                    credentials: 'include',
                    body: formData
                }).then((res) => res.json())
                .then((data) => {
                    if(data&&data.sucess === true){
                      setLoading(false)
                        toast.success(data.messege)
                    }
                    else if(data&&data.sucess === false){
                      setLoading(false)
                        toast.error(data.messege)
                    }
                })
                .catch((error) => {
                  setLoading(false)
                    if(error){
                        toast.error(error.messege|| 'Something Went Wrong')
                    }
                })
            }

            e.target.reset()
    }


  return (
    <div className='mt-16 pb-10 pt-4'>
      <div className='flex flex-col items-center gap-5'>
        <h1 className='text-center text-2xl font-serif'>Add Foods Here</h1>
        {loading?<FullScreenLoader/>:null}
        <form onSubmit={handleAddFood} className='flex flex-col items-center justify-evenly gap-2 w-[90%] h-[100%] bg-blue-300 p-4 rounded-[10px] sm:w-[80%] lg:w-[70%]'>
        <input required type="text" placeholder='Food Title' name="title" className='border-[0.5px] p-2 outline-0 rounded-[8px] w-[80%] active:bg-none focus:bg-none placeholder:text-black '/>
        <div className='w-[80%] flex flex-col items-start gap-1'>
          <p className=' font-bold'>Profile Image</p>
        <input required type="file" placeholder='Food Image' name="file" className='border-[0.5px] p-2  rounded-[8px] w-[100%] '/>
        </div>
        <textarea rows={10} required type="text" placeholder='Food Description' name="description" className='border-[0.5px] resize-none p-2 outline-0 rounded-[8px] w-[80%] active:bg-none placeholder:text-black '/>
        <select name="category" required placeholder = 'Category' className='border-[0.5px] p-2 w-[80%] rounded-[8px] cursor-pointer'>
            <option value="Special Offers & Deals">Special Offers & Deals</option>
            <option value="Fast Foods">Fast Foods</option>
            <option value="BBQ & Grilled">BBQ & Grilled</option>
            <option value="Cuisines">Cuisines</option>
            <option value="Meal Types">Meal Types</option>
            <option value="Beverages">Beverages</option>
            <option value="Desserts & Sweets">Desserts & Sweets</option>
        </select>
        <div className='w-[80%] flex items-center'>
            <input required type='text' placeholder='Price' name="price" className=' p-2 outline-0 w-[100%] active:bg-none placeholder:text-black border-[0.5px] rounded-[8px]'/>
        </div>
        <div className='w-[80%] flex justify-evenly'>
          <button type='reset' className='cursor-pointer border-[0.5px] p-3 rounded-2xl hover:bg-blue-200' style={{transition: '0.5s'}}>Reset</button>
          <button type='submit' className='cursor-pointer border-[0.5px] p-2 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Add</button>
        </div>
      </form>
      </div>
    </div>
  )
}

export default Foods
